export enum DefaultFoodIconSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
